import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { CargoLocationReportComponent } from '../cargo-location-report/cargo-location-report.component';
import { Utils } from 'src/app/core/resources/utils';
import { SnackBarService } from 'src/app/core/services/snackBar.service';
import { Permission } from 'src/app/core/resources/permission';
import { CargoTrackingService } from '../cargo-tracking/cargo-tracking.service';
import { PermissionRole } from 'src/app/core/resources/permission-role';
import { LastPointLocation, Traceability } from 'src/app/core/interfaces/lastPointLocation';
import { CargoMessages } from 'src/app/core/messages/cargo-messages.enum';
import { ModalEnum } from 'src/app/core/enums/modal.enum';
import { AngularFireStorage } from '@angular/fire/storage';
import { Cargo } from 'src/app/core/interfaces/cargo';
import { EvidenceViewerComponent } from 'src/app/shared/evidence-viewer/evidence-viewer.component';
import { Global } from 'src/app/core/resources/global';
import { StorageEndpoints } from 'src/app/core/resources/storage-endpoints';
import { Fmt } from 'src/app/core/messages/fmt';
import { FileService } from 'src/app/shared/files/file.service';
import { ModalSelectionMapComponent } from 'src/app/shared/modal-selection-map/modal-selection-map.component';
import { OptionsAutocomplete } from 'src/app/core/interfaces/optionsAutocomplete';
import { buildMapInfoWindow } from "src/app/core/resources/map-info-window";
@Component({
  selector: 'app-cargo-history-news',
  templateUrl: './cargo-history-news.component.html',
  styleUrls: ['./cargo-history-news.component.scss']
})
export class CargoHistoryNewsComponent implements OnInit {
  permission = Permission;
  isSomeChanged: boolean = false;
  tracepoints: LastPointLocation[] = [];
  noveltyImages: { pointId: number, images: { url: string, type: 'image' | 'pdf' }[] }[] = [];
  filteredHistoryNoveltyPoints: LastPointLocation[] = null;
  mapOptions: OptionsAutocomplete = {};
  locationsCargos: Object = {};
  tempListLocations: Object = {};
  constructor(
    public matDialog: MatDialog,
    public dialogRef: MatDialogRef<CargoHistoryNewsComponent>,
    public utils: Utils,
    private snackBarService: SnackBarService,
    public global: Global,
    public cargoTrackingService: CargoTrackingService,
    private permissionRole: PermissionRole,
    private fileService: FileService,
    private _angularFireStorage: AngularFireStorage,
    @Inject(MAT_DIALOG_DATA) public data: {
      tracepoints: Traceability,
      cargo: Cargo,
      title: string
    }) { }

  ngOnInit() {
    if (this.data && this.data.tracepoints) {
      this.tracepoints = this.data.tracepoints.tracepoints;
      this.getTracepointImages();
      this.filteredHistoryNoveltyPoints = this.tracepoints;
      this.setMapTracepoints();
    }
  }

  filterTracepoints($event: LastPointLocation[]) {
    this.filteredHistoryNoveltyPoints = $event;
    this.setMapTracepoints();
  }

  mapOptionsConfig(options: OptionsAutocomplete) {
    this.mapOptions = { ...this.mapOptions, ...options };
  }

  private setMapTracepoints() {
    const points = this.filteredHistoryNoveltyPoints !== null
      ? this.filteredHistoryNoveltyPoints
      : this.tracepoints;
    const mapPoints = [];
    if (points && points.length) {
      const path = points
        .filter(point => point && point.location && point.location.lat && point.location.lng)
        .map((point, index) => {
          const isFirst = index === 0;
          const isLast = index === points.length - 1;
          return {
            key: `history-marker-${point.id || index}`,
            lat: point.location.lat,
            lng: point.location.lng,
            icon: isFirst ? this.global.pathMarkerOrigin : isLast ? this.global.pathMarkerVehicle : this.global.pathMarkerDestination,
            contentInfoWindow: buildMapInfoWindow({
              icon: 'fas fa-exclamation-circle',
              title: point.name ? point.name : point.anomaly ? point.anomaly : 'Novedad',
              subtitle: point.fingerprint && point.fingerprint.date ? point.fingerprint.date.slice(0, 16) : '',
              footer: point.address ? point.address : ''
            }),
            showMarker: true,
            setCenter: isLast,
            zoom: 12
          };
        });

      mapPoints.push(...path);
      this.tempListLocations[this.data.cargo.id] = {
        path: mapPoints,
        showPolyline: mapPoints.length > 1
      };
    } else {
      this.tempListLocations[this.data.cargo.id] = { path: [], showPolyline: false };
    }
    this.locationsCargos = this.tempListLocations;
    this.mapOptionsConfig({
      initialMarkers: true,
      initialRealRoute: true,
      route: this.locationsCargos,
      polyline: this.locationsCargos,
      removeAllPolylines: true
    });
  }

  private getTracepointImages() {
    this.noveltyImages = [];
    if (this.tracepoints && this.tracepoints.length)
      this.tracepoints.forEach(async tracepoint => {
        const images = [];
        if (tracepoint.images && tracepoint.images.length)
          for (const image of tracepoint.images) {
            const url = await this.getDownloadURL(image) || this.global.pathNoImage;
            const type = image.split('.').pop() || 'image';
            images.push({ url, type: type.toLowerCase() === 'pdf' ? 'pdf' : 'image' });
          }
        if (images.length)
          this.noveltyImages.push({ pointId: tracepoint.id, images });
      })
  }

  public updateNovelty(novelty) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      cargo: this.data.cargo,
      report: {
        parent: "tripAnomalies",
      }
    }
    if (novelty.name || novelty.anomaly)
      dialogConfig.data.report['name'] = novelty.name ? novelty.name : novelty.anomaly;
    if (novelty.observation)
      dialogConfig.data.report['observation'] = novelty.observation;
    if (novelty.fingerprint && novelty.fingerprint.date)
      dialogConfig.data.report['date'] = novelty.fingerprint.date;
    if (novelty.temperature)
      dialogConfig.data.report['temperature'] = novelty.temperature;
    if (novelty.images && novelty.images.length)
      dialogConfig.data.report['images'] = this.getNoveltyImages(novelty.id);
    dialogConfig.width = ModalEnum.MEDIUM_WIDTH;
    dialogConfig.autoFocus = false;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    const dialogRef = this.matDialog.open(CargoLocationReportComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (!this.utils.isEmpty(result) && !this.utils.isEmpty(result.state) && result.state) {
        this.snackBarService.openSnackBar(CargoMessages.NOVELTY_UPDATED);
        if (result.cargo) {
          this.refreshTracepoints();
          this.isSomeChanged = true;
        }
      }
      if (!this.utils.isEmpty(result) && !this.utils.isEmpty(result.state) && !result.state) {
        this.snackBarService.openSnackBar(CargoMessages.NOVELTY_UPDATE_ERROR, undefined, 'error');
      }
    });
  }

  get canEditAnomaly(): boolean {
    return this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.editAnomalies);
  }

  public refreshTracepoints() {
    this.cargoTrackingService.getTracking(this.data.cargo.id).subscribe(
      (data: Traceability) => {
        this.tracepoints = data && data.tracepoints ? data.tracepoints : [];
      },
      error => {
        this.tracepoints = [];
      })
  }

  public closeDialog() {
    this.isSomeChanged
      ? this.dialogRef.close({
        state: true,
      })
      : this.dialogRef.close();
  }

  async getDownloadURL(fileName: string): Promise<string> {
    if (!fileName) return null;
    const path = Fmt.string(StorageEndpoints.cargoLocationReportEvidences, this.data.cargo.id);
    const url = `${path}/${fileName}`;
    try {
      const response = await this.fileService.getURLDocument(url).toPromise();
      if (!response || response.code_ === "storage/object-not-found")
        return null;
      return response;
    } catch (error) {
      return null;
    }
  }

  getNoveltyImages(pointId: number): { url: string, type: 'image' | 'pdf' }[] {
    const element = this.noveltyImages.find(image => image.pointId === pointId);
    return element ? element.images : [];
  }

  openImageNewTab(index: number, pointId: number) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = { evidences: this.getNoveltyImages(pointId), index };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.LARGE_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    this.matDialog.open(EvidenceViewerComponent, dialogConfig);
  }

  checkLocation(tracePoint: LastPointLocation) {
    const dialogConfig = new MatDialogConfig();
    const address = this.utils.getNestedValue(tracePoint, 'address');
    const location = this.utils.getNestedValue(tracePoint, 'location');
    const observation = this.utils.getNestedValue(tracePoint, 'observation');
    if (!location || !location.lat || !location.lng)
      return this.snackBarService.openSnackBar('No es posible acceder a la ubicación de esta novedad.', undefined, 'alert');

    dialogConfig.data = { initialValue: { address: address ? address : observation ? observation : 'Reporte de GPS', location } };
    dialogConfig.height = ModalEnum.MEDIUM_HEIGHT;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.EXTRA_SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    this.matDialog.open(ModalSelectionMapComponent, dialogConfig);
  }

}
